import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import ManagePage from '../../views/ManagePage/';
const GLOBAL = require('../../Globals');

class AddUser extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			uname : '',
			ugender : '',
			udob : '',
			uaddress : '',
			country : '',
			state : '',
			uemail : '',
			username : '',
			upass : '',
			ucity : '',
			umobile : '',
			urole : '',
			ustatus : '',
			_message : '',
			value : '',
			alertClass :'',
			_redirect : '',
			employees : [],
			region : '',
		}
		/** bind function **/
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	/** set value **/
	onChange(e){
		if(e.target.name == 'urole'){
			this.state.urole = e.target.value;
		}
		this.setState({[e.target.name]:e.target.value});
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('user/add',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'User Added Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("userform").reset();
			}
			else{
		
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	selectCountry (val) {
		this.setState({ country: val });
	}
 
	selectRegion (val) {
		this.setState({ region: val });
	}

	componentDidMount(){
		this.getdata();
	}

	getdata() {
		$("#showLoader").show();
		GetData('employee/getemployee').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					employees: responseJson
				});
			}
		});
	}
	
  render() {
	  
	const { country, region } = this.state;
	
	this.gen = [
		{value : '', name : 'Select Gender'},
		{value : 'male', name : 'Male'},
		{value : 'female', name : 'Female'}
	];
	
	/** set status select box **/
	this.userstatus = [
		{value : '', name : 'Select'},
		{value : 'active', name : 'Active'},
		{value : 'block', name : 'Block'}
	];
	
	/** set userrole select box **/
	this.userrole = [
		{value : '', name : 'Select'},
		{value : 'admin', name : 'Admin'},
		{value : 'staff', name : 'Staff'},
		{value : 'markentry', name : 'Mark entry'},
		{value : 'classteacher', name : 'Class Teacher'},
		{value : 'questionbank', name : 'Question Bank'},
		{value : 'library', name : 'Library'},
		{value : 'smsapp', name : 'Sms App'},
		{value : 'accountant', name : 'Accountant'}
	];
	
	/** Redirect to update page **/
	if(this.state._redirect){
		  
		return (<Redirect to={'/settings/academicupdate/'+this.state.idd} />);

	}
	
    return (
		<div>
		  <ManagePage />
			<div className="animated fadeIn">
			  <form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit}>
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
						<CardHeader>
							<strong>Add User</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Name <span className="text-danger">*</span></Label>
								  <input type="text" name="uname" className="form-control" onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Email</Label>
								  <input type="email" name="uemail" className="form-control" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Gender <span className="text-danger">*</span></Label>
								  <select name="ugender" className="form-control" onChange={this.onChange} required>
									{this.gen.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Dob</Label>
								  <input type="date" name="udob" className="form-control" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Username <span className="text-danger">*</span></Label>
								  <input type="text" name="username" className="form-control" onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Password <span className="text-danger">*</span></Label>
								  <input type="password" name="upass" className="form-control" onChange={this.onChange} required/>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Address</Label>
								  <input type="text" name="uaddress" className="form-control" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">City</Label>
								  <input type="text" name="ucity" className="form-control" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Mobile</Label>
								  <input type="number" name="umobile" className="form-control" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Country</Label>
								  <CountryDropdown value={country} onChange={(val) => this.selectCountry(val)} id="con" />
								</FormGroup>
							  </Col>
							   <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">State</Label>
								 <RegionDropdown country={country} value={region} onChange={(val) => this.selectRegion(val)} id="con" />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Role <span className="text-danger">*</span></Label>
								  <select name="urole" className="form-control" onChange={this.onChange} required>
									{this.userrole.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
							  {(this.state.urole == 'questionbank' || this.state.urole == 'markentry' || this.state.urole == 'classteacher') ?
							  <Col md="3">
								  <FormGroup>
									  <Label>Staff <span className="text-danger">*</span></Label>
									  <select name="staffid" className="form-control" onChange={this.onChange} required>
										  <option value="">Select Staff</option>
										{this.state.employees.map((e, key) => {
											return <option key={key} value={e.id}>{e.empcode} - {e.empname}</option>;
										})}		
									  </select>
								  </FormGroup>
							  </Col> : ''}
							   <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Status <span className="text-danger">*</span></Label>
								  <select name="ustatus" className="form-control" onChange={this.onChange} required>
									{this.userstatus.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary" className="btn-right"><i className="fa fa-dot-circle-o"></i> Save User</Button>
						</CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default AddUser;


// WEBPACK FOOTER //
// ./src/users/AllUser/AddUser.js